import './forgot_pwd.css';
import { Header } from '../../components/header/Header';
import { useState } from 'react';
import { useLang } from '../../context/LangContext';
import { BarLoader } from '../../components/BarLoader/BarLoader';
import { Link } from 'react-router-dom';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';

export function ForgotPwd() {
    //HOOKS
    const { lang } = useLang();
    const { postRequest } = useServer();

    //STATES
    const [email, setEmail] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    //FUNCTIONS
    const requestPasswordReset = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        postRequest(endpoints.requestPasswordReset, { email: email }, (res) => {
            setLoading(false);
    
            if (res[0]) {
                res = res[1];
                if (res.success) {
                    setErrorMsg(lang === "en" ? "If the email is associated with an account, you will receive an email to reset the password." : "Si el correo esta asociado a una cuenta, recibiras un correo para restablecer la contraseña");
                } else {
                    setErrorMsg(lang === "en" ? "All fields are required" : "Todos los campos son requeridos");
                }
            } else {
                setErrorMsg(lang === "en" ? "Server error, please try again in a bit": "Error del servidor, intenta de nuevo en un momento");
            }
        });
    }

    return (
        <>
            <Header />
            <div className='forgot_form_body'>
                <div className='form'>
                    <div className='input_container'>
                        <label>
                            { lang === "en" ? "Email": "Correo electrónico" }
                        </label>
                        <input type='text' placeholder={ lang === "en" ? "Email": "Correo electrónico" } value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    {errorMsg !== "" && 
                        (
                            <div className='error_msg'>
                                {errorMsg}
                            </div>
                        )
                    }
                    <button onClick={requestPasswordReset}>
                        { lang === "en" ? "Recover password" : "Recuperar contraseña"}
                    </button>
                    {loading && 
                        (
                            <div className='loader'>
                                <BarLoader />
                            </div>
                        )
                    }
                    <Link to='/login'>
                        { lang === "en" ? (
                            <>
                                Already have an account? <Link to='/login'>Login</Link>
                            </>
                        ) : (
                            <>
                                ¿Ya tienes una cuenta? <Link to='/login'>Inicia sesión</Link>
                            </>
                        )}
                    </Link>
                    <Link to='/register'>
                        { lang === "en" ? "Don't have an account? Sign up" : "¿No tienes una cuenta? Registrate" }
                    </Link>
                </div>
            </div>
        </>
    );
}